module.exports = __webpack_public_path__ + "img/ez-slot-category-brand-mobile.1faaca31.png";